import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "l-inner" }
const _hoisted_2 = ["src", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.content !='')
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(_ctx.classes)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("iframe", {
            src: _ctx.content,
            ref: "refFrame",
            width: "100%",
            height: _ctx.ifheight,
            frameborder: "0",
            scrolling: "no",
            allow: "fullscreen *",
            loading: "lazy"
          }, null, 8, _hoisted_2)
        ])
      ], 2))
    : _createCommentVNode("", true)
}